import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography, Grid, MenuItem, TableContainer, Table, TableHead, TableBody, IconButton, Snackbar, Autocomplete } from "@mui/material";
import { ActionMsg, Breadcrumb, Cancel, CTSinput, HandleCloseSnackbar, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import { getDriverList, getVehicleList, getDepotList, getProductList, getCylinderList, editDeleteTempoloading, addTempoloading } from "../../../actions/actions";
import dayjs from 'dayjs';
import tempoLoadingService from '../../../services/tempoLoadingService';
import depotMasterService from '../../../services/masters/depotMaster.Service';
import driverMaster from '../../../services/masters/driverMaster.Service';
import productMasterService from '../../../services/masters/productMaster.Service';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
import driverMasterService from '../../../services/masters/driverMaster.Service';
import customerMasterService from '../../../services/masters/customerMaster.Service';


const Add_tempo_loadings = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { handleSubmit } = useForm();
    const location = useLocation();
    const editData = location.state || null;
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    const depot_id = userInfo.depot_id;
    const short_code = userInfo.short_code;



    const [successMessage, setSuccessMessage] = useState("");
    const [data, setData] = useState({
        tempo_loading_id: editData ? editData.tempo_loading_id : undefined,
        entry_no: editData?.entry_no || '',
        entry_date: editData?.entry_date ? new Date(editData.entry_date).toISOString().split("T")[0] : "",
        driver_id: editData?.driver_id || '',
        from_depot: editData?.from_depot || '',
        to_tempo: editData?.to_tempo || '',
        loading_time: editData?.loading_time || '',
        route_no: editData?.route_no || '',
        fin_year: editData?.fin_year || '',

    });

    const [driverList, setDriver] = useState([]);
    const [depotList, setDepot] = useState([]);
    const [productList, setProduct] = useState([]);
    const [vehicleList, setVehicle] = useState([]);
    const [cylinderList, setCylinder] = useState([]);
    const [customerList, setCustomer] = useState([]);


    useEffect(() => {
        async function fetchData() {
            try {
                const [driverData, depotData, productData, cylinderData, vehicleData, customerDate] = await Promise.all([
                    driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
                    depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
                    productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
                    cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
                    vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
                    customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
                ]);

                setDepot(depotData);
                setDriver(driverData);
                setProduct(productData);
                setCylinder(cylinderData);
                setVehicle(vehicleData);
                setCustomer(customerDate)

            } catch (error) {
                console.error("Data fetching failed", error);
            }
        }

        fetchData();
    }, []);

    const [tempoDetails, setTempoDetails] = useState(
        editData?.table_details ? JSON.parse(editData.table_details) : [{ srno: "", customer_name: "", cyl_no: "", prod_code: "", prod_description: "", dc_No: "" }]
    );


    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setData(prev => ({ ...prev, [name]: value }));
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setData(prev => {
            const updatedData = {
                ...prev,
                [name]: value,
            };

            if (name === 'entry_date') {
                const selectedDate = new Date(value);
                const month = selectedDate.getMonth(); // Jan = 0
                const year = selectedDate.getFullYear();
                const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
                updatedData.fin_year = financialYear;
            }

            return updatedData;
        });
    };


    const handleChangeInput = (e, index) => {
        const { name, value } = e.target;
        const updated = [...tempoDetails];
        updated[index][name] = value;

        if (name === "prod_code") {
            const selectedProduct = productList.find(prod => prod.prod_code === value);
            updated[index]["prod_description"] = selectedProduct?.prod_description || "";
        }

        setTempoDetails(updated);
    };


    const handleAddSPQuotationFields = () => {
        const newRow = { srno: "", cyl_no: "", prod_code: "", prod_description: "", qtykg: "", qtycm: "" };
        setTempoDetails(prev => [...prev, newRow]);
    };


    const handleRemovepickup = (index) => {
        setTempoDetails(prev => prev.filter((_, i) => i !== index));
    };


    const onSubmit = async () => {
        const currentTimestamp = dayjs().format('YYYY-MM-DD HH:mm:ss');
        const isEdit = Boolean(editData);

        const tempoLoadingPayload = {
            ...data,
            entry_no: isEdit ? editData.entry_no : '',
            entry_date: data.entry_date,
            driver_id: data.driver_id,
            from_depot: data.from_depot,
            to_tempo: data.to_tempo,
            loading_time: data.loading_time,
            route_no: data.route_no,
            table_details: JSON.stringify(tempoDetails),
            created_at: isEdit ? editData.created_at : currentTimestamp,
            created_by: isEdit ? editData.created_by : userInfo.user_id,
            modified_at: currentTimestamp,
            modified_by: userInfo.user_id,
            changedUpdatedValue: isEdit ? 'edit' : 'add',
            depot_id: depot_id,
            short_code: short_code,
        };

        try {
            if (editData) {
                await tempoLoadingService.editDeleteTempoloading(tempoLoadingPayload);
            } else {
                await tempoLoadingService.addTempoloading(tempoLoadingPayload);
            }
            setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
            setTimeout(() => navigate(-1), 1000);
            //  setTimeout(()=>navigate(-1),1000);
        } catch (error) {
            setSuccessMessage("Error occurred");
        }
    };
    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb routeSegments={[{ name: "Vehicle Loading Entry" }]} />



                <Box>

                    <Box sx={{ display: "flex" }}>
                        <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                            <Grid item md={7} sm={6} xs={12}>
                                <Box sx={{ display: "flex" }}>
                                    <Typography className={`${styles.header_txt}`}>
                                        VEHICLE LOADING
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={6} >
                                <Grid container spacing={0.6}>

                                    <Grid item xs={10} sm={10}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}>
                                            <Typography className={`${styles.label_Txt}`}>
                                                From Depot
                                            </Typography>
                                            <Autocomplete
                                                disablePortal
                                                options={depotList || []}
                                                clearIcon={false}
                                                getOptionLabel={(option) =>
                                                    typeof option === 'string' ? option : option.depot_name || ''
                                                }
                                                value={
                                                    depotList.find((d) => d.depot_id === data.from_depot) ||
                                                    (data.from_depot ? { depot_id: data.from_depot } : null)
                                                }
                                                onChange={(event, newValue) => {
                                                    handleChange({
                                                        target: {
                                                            name: 'from_depot',
                                                            value: newValue ? newValue.depot_id : '',
                                                        },
                                                    });
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.depot_id === value.depot_id
                                                }
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} className={styles.cts_lable}>
                                                        {option.depot_name}
                                                    </MenuItem>
                                                )}
                                                renderInput={(params) => (
                                                    <CTSinput
                                                        {...params}
                                                        // label="From Depot"
                                                        // placeholder="Select or type depot"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            className: styles.CTSinput_Box,
                                                        }}
                                                    />
                                                )}
                                                sx={{ width: '100%' }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={10} sm={10}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}>
                                            <Typography className={`${styles.label_Txt}`}>
                                                To Tempo
                                            </Typography>

                                            <Autocomplete
                                                disablePortal
                                                options={vehicleList || []}
                                                clearIcon={false}
                                                getOptionLabel={(option) =>
                                                    typeof option === 'string' ? option : option.vehicle_no || ''
                                                }
                                                value={
                                                    vehicleList.find((v) => v.vehicle_id === data.to_tempo) ||
                                                    (data.to_tempo ? { vehicle_id: data.to_tempo } : null)
                                                }
                                                onChange={(event, newValue) => {
                                                    handleChange({
                                                        target: {
                                                            name: 'to_tempo',
                                                            value: newValue ? newValue.vehicle_id : '',
                                                        },
                                                    });
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.vehicle_id === value.vehicle_id
                                                }
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} className={styles.cts_lable}>
                                                        {option.vehicle_no}
                                                    </MenuItem>
                                                )}
                                                renderInput={(params) => (
                                                    <CTSinput
                                                        {...params}
                                                        // label="To Tempo"
                                                        // placeholder="Select or type tempo number"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            className: styles.CTSinput_Box,
                                                        }}
                                                    />
                                                )}
                                                sx={{ width: '100%' }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={6} >
                                <Grid container spacing={0.6}>
                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Entry No
                                            </Typography>

                                            <CTSinput
                                                size="small"
                                                fullWidth
                                                name="entry_no"
                                                value={data.entry_no}
                                                onChange={handleChange}
                                                InputProps={{
                                                    readOnly: true,
                                                    className: styles.CTSinput_Box,
                                                    style: {
                                                        backgroundColor: "#f0f0f0",
                                                    },
                                                }}
                                            />

                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Entry Date
                                            </Typography>

                                            <CTSinput
                                                size="small"
                                                fullWidth
                                                type="date"
                                                name="entry_date"
                                                value={data.entry_date}
                                                onChange={handleChange}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            />

                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={5.5}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Financial Year
                                            </Typography>
                                            <CTSinput
                                                size="small"
                                                fullWidth
                                                value={data.fin_year}
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    className: styles.CTSinput_Box,
                                                    style: {
                                                        backgroundColor: "#f0f0f0",
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Driver
                                            </Typography>

                                            <Autocomplete
                                                disablePortal
                                                options={driverList || []}
                                                clearIcon={false}
                                                getOptionLabel={(option) =>
                                                    typeof option === 'string' ? option : option.driver_name || ''
                                                }
                                                value={
                                                    driverList.find((d) => d.driver_id === data.driver_id) ||
                                                    (data.driver_id ? { driver_id: data.driver_id } : null)
                                                }
                                                onChange={(event, newValue) => {
                                                    handleChange({
                                                        target: {
                                                            name: 'driver_id',
                                                            value: newValue ? newValue.driver_id : '',
                                                        },
                                                    });
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.driver_id === value.driver_id
                                                }
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} className={styles.cts_lable}>
                                                        {option.driver_name}
                                                    </MenuItem>
                                                )}
                                                renderInput={(params) => (
                                                    <CTSinput
                                                        {...params}
                                                        // label="Driver"
                                                        // placeholder="Select or type driver name"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            className: styles.CTSinput_Box,
                                                        }}
                                                    />
                                                )}
                                                sx={{ width: '100%' }}
                                            />

                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Loading Time
                                            </Typography>

                                            <CTSinput
                                                id="loading-time"
                                                size="small"
                                                type="time"
                                                fullWidth
                                                name="loading_time"
                                                value={data.loading_time}
                                                onChange={handleChange}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            >

                                            </CTSinput>

                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                                // gap: { xs: 1, sm: 2 },
                                            }}
                                        >
                                            <Typography className={`${styles.label_Txt}`}>
                                                Route No
                                            </Typography>

                                            <CTSinput
                                                id="loading-time"
                                                size="small"
                                                fullWidth
                                                name="route_no"
                                                value={data.route_no}
                                                onChange={handleChange}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            >

                                            </CTSinput>

                                        </Box>
                                    </Grid>

                                </Grid>
                            </Grid>



                            <Grid item xs={12}>
                                <TableContainer className={`${styles.list_tbl_container}`}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align="left" sx={{ width: '10%' }} className={`${styles.table_head}`}>Sr No</StyledTableCell>
                                                <StyledTableCell align="left" sx={{ width: '10%' }} className={`${styles.table_head}`}>Customer Name</StyledTableCell>
                                                <StyledTableCell align="left" sx={{ width: '10%' }} className={`${styles.table_head}`}>DC NO</StyledTableCell>
                                                <StyledTableCell align="left" sx={{ width: '15%' }} className={`${styles.table_head}`}>Cylinder No</StyledTableCell>
                                                <StyledTableCell align="left" sx={{ width: '15%' }} className={`${styles.table_head}`}>Product Code</StyledTableCell>
                                                <StyledTableCell align="left" sx={{ width: '20%' }} className={`${styles.table_head}`}>Product Description</StyledTableCell>


                                                <StyledTableCell align="center" className={`${styles.table_head}`} >
                                                    Action
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tempoDetails?.map((row, index) => (
                                                <StyledTableRow key={index}>
                                                    <StyledTableCell align="left">{index + 1}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <CTSinput align="left"
                                                            fullWidth
                                                            placeholder='select '
                                                            size="small"
                                                            variant="standard"
                                                            name="customer_name"

                                                            value={row.customer_name}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            // InputProps={{ disableUnderline: true }}
                                                            select
                                                        >
                                                            {customerList?.length > 0 ? (
                                                                customerList.map((c) => (
                                                                    <MenuItem key={c.cust_id} value={c.cust_name} className={`${styles.cts_lable}`}>
                                                                        {c.cust_name}
                                                                    </MenuItem>
                                                                ))
                                                            ) : (
                                                                <MenuItem disabled className={`${styles.cts_lable}`}>No cylinders available</MenuItem>
                                                            )}
                                                        </CTSinput>
                                                    </StyledTableCell>

                                                    <StyledTableCell>
                                                        <CTSinput align="left"
                                                            fullWidth
                                                            placeholder='DC No'
                                                            size="small"
                                                            variant="standard"
                                                            name="dc_no"
                                                            value={row.dc_no}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                        // InputProps={{ disableUnderline: true }}
                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell>
                                                        <CTSinput align="left"
                                                            fullWidth
                                                            placeholder='select '
                                                            size="small"
                                                            variant="standard"
                                                            name="cyl_no"
                                                            value={row.cyl_no}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            // InputProps={{ disableUnderline: true }}
                                                            select
                                                        >
                                                            {cylinderList?.length > 0 ? (
                                                                cylinderList.map((cyl) => (
                                                                    <MenuItem key={cyl.cyl_id} value={cyl.cylinder_no} className={`${styles.cts_lable}`}>
                                                                        {cyl.cylinder_no}
                                                                    </MenuItem>
                                                                ))
                                                            ) : (
                                                                <MenuItem disabled className={`${styles.cts_lable}`}>No cylinders available</MenuItem>
                                                            )}
                                                        </CTSinput>
                                                    </StyledTableCell>


                                                    <StyledTableCell>
                                                        <CTSinput align="left"
                                                            fullWidth
                                                            size="small"
                                                            variant="standard"
                                                            name="prod_code"
                                                            value={row.prod_code}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            // InputProps={{ disableUnderline: true }}
                                                            select
                                                        >
                                                            {productList?.length > 0 ? (
                                                                productList.map((product) => (
                                                                    <MenuItem key={product.prod_id} value={product.prod_code} className={`${styles.cts_lable}`}>
                                                                        {product.prod_code}
                                                                    </MenuItem>
                                                                ))
                                                            ) : (
                                                                <MenuItem disabled className={`${styles.cts_lable}`}>No product codes available</MenuItem>
                                                            )}
                                                        </CTSinput>
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CTSinput align="left"
                                                            fullWidth
                                                            size="small"
                                                            variant="standard"
                                                            name="prod_description"
                                                            value={row.prod_description}
                                                            InputProps={{
                                                                // disableUnderline: true, 
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </StyledTableCell>


                                                    <StyledTableCell align="center">
                                                        <Box display="flex" justifyContent="center">
                                                            <IconButton size="small" onClick={handleAddSPQuotationFields}>
                                                                <AddIcon sx={{ fontSize: 16, color: "#1b52d1", border: "1px solid #1b52d1", borderRadius: "50%" }} />
                                                            </IconButton>
                                                            {index !== 0 && (
                                                                <IconButton size="small" onClick={() => handleRemovepickup(index)}>
                                                                    <DeleteForeverIcon sx={{ fontSize: 18, color: "red" }} />
                                                                </IconButton>
                                                            )}
                                                        </Box>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>




                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                <Box className={`${styles.btn_container}`}>
                                    <Box>
                                        <Button
                                            id={`${styles.btn_save}`}
                                            type="submit">
                                            <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                                            <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Cancel />
                                    </Box>
                                </Box>
                            </Grid>


                        </Grid>
                    </form>
                </Box>




                {/* Success Message Snackbar */}
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={Boolean(successMessage)}
                    autoHideDuration={2000}
                    onClose={(event, reason) => HandleCloseSnackbar(event, reason, setSuccessMessage)}
                    message={successMessage}
                    action={ActionMsg(setSuccessMessage)}
                />
            </Box>
        </Box>
    );
};

export default Add_tempo_loadings;
